import { default as activity } from './activity/services'
import { default as category } from  './category/services'

export default {
    ...activity,
    ...category,
}